import jQuery from 'jquery';

const computeImageHash = async (src) => {
  return new Promise((resolve, _reject) => {
    jQuery.get({
      url: `https://image-hash.benable.com/?src=${encodeURIComponent(src)}`,
      success: (data) => {
        resolve(data);
      },
      error: (_data) => {
        resolve();
      },
    });
  });
};

const dedupImages = (images, selectedImages) => {
  let keys = {};

  images.forEach((img) => {
    if (img.hash && keys[img.hash] && !selectedImages.includes(img)) {
      img.duplicate = true;
    } else if (img.hash) {
      keys[img.hash] = true;
    }
  });

  return images;
};

export default {
  computeImageHash,
  dedupImages,
};
